const React = require("react")

const IconFolder = require("assets/svg/folder.svg")
const IconCalendar = require("assets/svg/calendar.svg")
const IconDocument = require("assets/svg/document.svg")
const IconSmarphone = require("assets/svg/smartphone.svg")
const IconWalletInformation = require("assets/svg/cracha-informacao.svg")
const IconActivation = require("assets/svg/activation.svg")

module.exports = {
  folder: <IconFolder />,
  calendar: <IconCalendar />,
  document: <IconDocument />,
  smartphone: <IconSmarphone />,
  walletInformation: <IconWalletInformation />,
  activation: <IconActivation />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/generalProductInformation/index.js